<div id="promotionPopup" [ngClass]="promotionpopup">
    <div class="popup-content">
        <h3>Select Promotion Piece</h3>
        <div class="piece-options">
            <img src="/assets/chesspieces/alpha/bQ.png" id="queen" alt="Queen" />
            <img src="/assets/chesspieces/alpha/bR.png" id="rook" alt="Rook" />
            <img src="/assets/chesspieces/alpha/bB.png" id="bishop" alt="Bishop" />
            <img src="/assets/chesspieces/alpha/bN.png" id="knight" alt="Knight" />
        </div>
    </div>
</div>